import React from 'react';
import PropTypes from 'prop-types';
import { PopoverItem } from '../ui/Popover';
import { qa } from '../api';

const ArchiveIssue = ({ projectID, issue, doAction }) => (
  <PopoverItem
    label="Archive"
    onClick={() => doAction(qa.archiveIssue(projectID, issue.id))}
  />
);

ArchiveIssue.propTypes = {
  projectID: PropTypes.string.isRequired,
  issue: PropTypes.object.isRequired,
  doAction: PropTypes.func.isRequired,
};

export default ArchiveIssue;
